import { supabase } from "@/integrations/supabase/client";
import { useUserAccess } from "./useUserAccess";

export const useTrial = () => {
  const { isOnTrial, isTrialExpired, daysRemaining, trialEnd, isLoading, isFreeGift, checkUserAccess: checkTrialStatus } = useUserAccess();

  const createTrial = async (userId: string) => {
    try {
      const trialEnd = new Date();
      trialEnd.setDate(trialEnd.getDate() + 7); // 7 days from now
      
      const { error } = await supabase
        .from('trials')
        .insert({
          user_id: userId,
          subscribed: true,
          trial_tier: 'trial',
          trial_end: trialEnd.toISOString(),
        });
      
      if (error) {
        console.error('Error creating trial:', error);
        throw error;
      }
      
      console.log('Trial created successfully for user:', userId);
    } catch (error) {
      console.error('Error creating trial:', error);
      throw error;
    }
  };

  return {
    isOnTrial,
    isTrialExpired,
    daysRemaining,
    trialEnd,
    isLoading,
    checkTrialStatus,
    createTrial,
    isFreeGift,
  };
};